import { UserState } from './types';
import User from '../../types/auth/User';

export default {
  setUser(state: UserState, user: User) {
    state.user = user;
  }
};
